var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// React
import React from 'react';
// Material ui
import { Box, Button, Fab, Grid } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
// Models
import { InputType } from '../../models/FormTypes';
// Styles
import { useFormStyle } from '../FormBuilder/form.style';
// Components
import FormField from '../FormField';
import Group from '../Group';
/**
 * Get next button element
 * @param groupIndex
 * @param stepper
 * @param currentStep
 * @param groupList
 * @param nextStep
 * @param index
 */
var NextButton = function (_a) {
    var groupIndex = _a.groupIndex, stepper = _a.stepper, currentStep = _a.currentStep, groupList = _a.groupList, nextStep = _a.nextStep;
    var isLastGroup = groupIndex === groupList.length - 1;
    var nextButtonIsAvailable = stepper || (!stepper && isLastGroup);
    var handleNextStep = function (e) { return nextStep(e, groupIndex); };
    var nextStepAvailable = stepper && currentStep < groupList.length - 1;
    if (!nextButtonIsAvailable) {
        return null;
    }
    if (nextStepAvailable) {
        return (React.createElement(Grid, { item: true, container: true, alignContent: "center", justify: "center" },
            React.createElement(Box, { m: 2 },
                React.createElement(Button, { variant: "contained", color: "primary", onClick: handleNextStep }, "Suivant"))));
    }
    return (React.createElement(Grid, { item: true, container: true, alignContent: "center", justify: "center" },
        React.createElement(Box, { m: 2 },
            React.createElement(Button, { type: "submit", color: "primary", variant: "contained" }, "Enregistrer"))));
};
/**
 * Form component
 * @param props
 */
var Form = function (props) {
    /** Component properties */
    var Components = props.Components, display = props.display, formHandler = props.formHandler, data = props.data;
    /** Component classes */
    var classes = useFormStyle();
    /** Component state */
    var _a = React.useState(0), currentStep = _a[0], setCurrentStep = _a[1];
    /** Component display properties */
    var title = display.title, description = display.description, stepper = display.stepper, assetUrl = display.assetUrl;
    /** Component data properties */
    var groupList = data.groupList;
    /**
     * Handle display next step
     */
    var nextStep = function (evt, groupIndex) { return __awaiter(void 0, void 0, void 0, function () {
        var groupIsValid;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    evt.preventDefault();
                    return [4 /*yield*/, formHandler.handleGroupValidity(groupIndex)];
                case 1:
                    groupIsValid = _a.sent();
                    if (groupIsValid) {
                        setCurrentStep(currentStep + 1);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Handle display previous step
     */
    var prevStep = function () {
        setCurrentStep(currentStep - 1);
    };
    /**
     * Get field component props
     * @param label
     * @param options
     * @param fieldType
     * @param asyncOptions
     */
    var getFieldComponentAndProps = function (_a) {
        var label = _a.label, options = _a.options, fieldType = _a.fieldType, asyncOptions = _a.asyncOptions;
        switch (fieldType) {
            case 'text':
                return { Component: Components.FormInput, props: { type: InputType.text } };
            case 'number':
                return { Component: Components.FormInput, props: { type: InputType.number } };
            case 'date':
                return { Component: Components.FormInput, props: { type: InputType.date } };
            case 'checkbox':
                return { Component: Components.FormCheckbox, props: { label: label, options: options } };
            case 'radio-picture':
                return { Component: Components.FormRadioPicture, props: { label: label, options: options, assetUrl: assetUrl } };
            case 'select':
                return { Component: Components.FormSelect, props: { label: label, options: options } };
            case 'multi-select':
                return { Component: Components.FormMultiSelect, props: { label: label, options: options } };
            case 'text-autocomplete':
                return { Component: Components.FormAutocomplete, props: { label: label, asyncOptions: asyncOptions } };
            default:
                return null;
        }
    };
    /**
     * Get field group element
     * @param groupProps
     */
    var getFieldGroup = function (groupProps) {
        return groupProps.childrenProps.map(function (field, index) {
            var fieldComponentData = getFieldComponentAndProps(field);
            var defaultProps = {
                error: formHandler.touched[field.name] && Boolean(formHandler.errors[field.name]),
                helperText: formHandler.touched[field.name] ? formHandler.errors[field.name] : '',
                id: field.id,
                initialValue: data.initialValues[field.name],
                label: field.label,
                name: field.name,
                onBlur: formHandler.handleBlur,
                onChange: formHandler.handleChange,
                required: field.required,
            };
            return fieldComponentData &&
                React.createElement(FormField, { key: field.name, Component: fieldComponentData.Component, specificProps: fieldComponentData.props, defaultProps: defaultProps });
        });
    };
    // Render
    return React.createElement("form", { onSubmit: formHandler.handleSubmit, noValidate: true },
        (title || description) && !stepper && React.createElement(Components.FormHeader, { title: title, description: description }),
        stepper && currentStep > 0 && React.createElement(Fab, { "aria-label": "add", className: classes.fab, onClick: prevStep },
            React.createElement(ArrowBack, null)),
        groupList.map(function (groupProps, index) { return (React.createElement(Group, { key: index, description: groupProps.description, stepper: stepper, currentStep: currentStep, groupStep: index, title: stepper ? groupProps.createTitle : groupProps.title, nextButton: React.createElement(NextButton, { currentStep: currentStep, groupIndex: index, groupList: data.groupList, nextStep: nextStep, stepper: stepper }) }, getFieldGroup(groupProps))); }));
};
export default Form;
//# sourceMappingURL=index.js.map